export const normalizeCallingCode = (callingCode) =>
  String(callingCode || "").trim().replace(/^\+/, "");

export const normalizeNationalNumber = (value) =>
  String(value || "").replace(/\D/g, "");

export const resolveCallingCodeByCountryIso = (countryCodes, isoCode) => {
  const country = (countryCodes || []).find(
    (item) =>
      String(item?.code || "").trim().toUpperCase() ===
      String(isoCode || "").trim().toUpperCase()
  );

  return normalizeCallingCode(country?.calling_code);
};

/**
 * National digits for DB `actual_number`: strips leading calling code if the user pasted E.164-style input.
 * Does not prepend the country code (calling code is UI-only; `country_code` stores ISO).
 */
export const stripCallingCodeFromDigits = (input, callingCode) => {
  const digits = normalizeNationalNumber(input);
  const prefix = normalizeCallingCode(callingCode);

  if (!digits) {
    return "";
  }

  if (prefix && digits.startsWith(prefix)) {
    return digits.slice(prefix.length);
  }

  return digits;
};
